import { TrialLessonId } from './trialLessons'
export enum LocationKey {
  SHE_NAGOYA = 'she_nagoya',
  SHE_UMEDA = 'she_umeda',
  SHE_FUKUOKA = 'she_fukuoka',
}

export const mapLocationsKeyToName: { [key in LocationsKey]: string } = {
  [LocationKey.SHE_UMEDA]: '梅田',
  [LocationKey.SHE_NAGOYA]: '名古屋',
  [LocationKey.SHE_FUKUOKA]: '福岡',
}

export type LocationsKey =
  | LocationKey.SHE_UMEDA
  | LocationKey.SHE_NAGOYA
  | LocationKey.SHE_FUKUOKA

export enum LocationType {
  OFFICIAL_BASE = 'official_base',
  TEMPORARY = 'temporary',
}

export type OnlineLocation = null

export type SheLocation = {
  id: TrialLessonId
  key: LocationKey
  name: string
  short_name: string
  location_type: LocationType
  zipcode: string
  address: string
  access_summary?: string
  short_access_summary?: string
  access_description?: string
  google_map_url?: string
  image?: string
}

export function getLocationName(location?: SheLocation | OnlineLocation) {
  if (!location) {
    return 'オンライン'
  } else {
    return location.name
  }
}
